(function () {
    'use strict';

    function workflowInternalFilesController($rootScope, $scope, $state, $timeout, milestones, thumbnails,
        sessionData, workflowStateService, milestoneModalService, notifyService, toastr, scrollingService, workflowThumbnailsService) {
        var vm = this;
        vm.thumbnails = thumbnails;
        vm.sessionEntity = sessionData.Entity;
        vm.workflowData = workflowStateService.get();
        vm.workflowId = vm.workflowData.Id.split('/')[1];
        vm.hasNoContents = !vm.workflowData.InternalContent.InformationParts.some(function(informationPart) {
            return !informationPart.IsRemoved;
        });
        vm.isAddingInformationPart = false;
        vm.mode = 'Editor';

        vm.toggleAddMenuDropdown = function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            vm.isAddMenuOpen = !vm.isAddMenuOpen;
        };

        vm.addToPhaseMenuItems = [
            {
                label: 'Document',
                action: function () {
                    vm.activateAddDocument();
                },
                iconClass: 'fa fa-file-o'
            },
            {
                label: 'Question Set',
                action: function() {
                    vm.activateAddQuestionSet();
                },
                iconClass: 'fa fa-check-square-o'
            }
        ];

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            if (!toState.name.startsWith('workflow.internalfiles')) {
                return;
            }
            $state.go('workflow.internalfiles', { workflowId: vm.workflowData.Id.split('/')[1] });
        });

        $rootScope.$on('thumbnailsChanged', function (event, args) {
            try {
                workflowThumbnailsService.getThumbnails(vm.workflowId, vm.workflowData).then(function (data) {
                    Object.keys(data).forEach(function (key) {
                        if (!vm.thumbnails[key]) {
                            vm.thumbnails[key] = data[key];
                        }
                    });
                });
                $scope.$apply();
            } catch (error) {
                $log.warn('failed to replace thumbnails');
                $log.warn(error);
            }
        });

        if (!vm.workflowData.InternalContent.Access.View) {
            notifyService.notify('You do not have access to this part of the workflow', true);
            $state.go('workflow.navigator', { workflowId: vm.workflowData.Id.split('/')[1] });
        }

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });

        vm.activateAddQuestionSet = function () {
            vm.isAddingQuestionSet = !vm.isAddingQuestionSet;
            if (vm.isAddingQuestionSet) {
                $timeout(function () {
                    scrollingService.scrollTo('addWorkflowInformationPartQuestionSet', 260, 0, 0);
                }, 0);
            }
        }

        vm.activateAddDocument = function () {
            vm.isAddingDocument = !vm.isAddingDocument;
            if (vm.isAddingDocument) {
                $timeout(function () {
                    scrollingService.scrollTo('addWorkflowInformationPartDocument', 260, 0, 0);
                }, 0);
            }
        }

        vm.removeInformationPart = function (partIndex) {
            workflowStateService.removeInformationPartFromInternalContent(partIndex);
        }

        vm.updateDocumentPrompt = function (partIndex) {
            workflowStateService.updateDocumentPrompt(vm.workflowData.InternalContent, vm.workflowData.InternalContent.InformationParts[partIndex]);
        }

        vm.deleteUpload = function (documentData, blobIndex) {
            workflowStateService.deleteUpload(vm.workflowData.InternalContent, documentData, blobIndex);
        }

        vm.syncQuestionSet = function (questionSetData) {
            workflowStateService.syncQuestionSet(vm.workflowData.InternalContent, questionSetData);
        }

        vm.addingInformationPartType = '';
        vm.activateAddInformationPart = function (type) {
            vm.addingInformationPartType = type;
            vm.isAddingInformationPart = !vm.isAddingInformationPart;
        }

        vm.addInformationPart = function (informationPart) {
            workflowStateService.addInformationPartToInternalContent(informationPart);
        }

        vm.toggleWorkflowReorderMode = function () {
            if (!$rootScope.workflowReorderMode) {
                $rootScope.workflowReorderModeToast = toastr.info('You are currently reordering this content',
                    {
                        timeOut: 0,
                        extendedTimeOut: 0,
                        closeButton: true,
                        closeHtml: "<button>Stop reordering</button>",
                        onHidden: function () {
                            $rootScope.workflowReorderMode = false;
                        }
                    });
            } else {
                if ($rootScope.workflowReorderModeToast) {
                    toastr.clear($rootScope.workflowReorderModeToast);
                    delete $rootScope.workflowReorderModeToast;
                }
            }

            $rootScope.workflowReorderMode = !$rootScope.workflowReorderMode;
        }

        vm.reorderInformationParts = function (informationPartIndex) {
            vm.workflowData.InternalContent.InformationParts.splice(informationPartIndex, 1);
            workflowStateService.update(vm.workflowData);
        }

        $scope.$on('workflowUpdated', function () {
            vm.workflowData = workflowStateService.get();
            vm.hasNoContents = !vm.workflowData.InternalContent.InformationParts.some(function(informationPart) {
                return !informationPart.IsRemoved;
            });
        });
    }

    workflowInternalFilesController.$inject = ['$rootScope', '$scope', '$state', '$timeout', 'milestones', 'thumbnails',
        'sessionData', 'workflowStateService', 'milestoneModalService', 'notifyService', 'toastr', 'scrollingService','workflowThumbnailsService'];

    angular.module('ecap.workflow').controller('workflowInternalFilesController', workflowInternalFilesController);
})();
